import { useMemo } from 'react';
import { ShopFilterType } from '../state/types';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectSaleById } from '../state';

const useShopFilterName = (filter?: ShopFilterType) => {
  const [t] = useTranslation('shop');

  const sale = useSelector(
    (state) => typeof filter === 'number' && selectSaleById(state, filter),
  );

  const name = useMemo(() => {
    if (sale && sale.name) {
      return t('shopSaleLabel', {
        sale: sale.name,
        interpolation: { escapeValue: false },
      });
    } else if (filter) {
      return t(`shopFilter${filter}`);
    }
  }, [filter, t, sale]);

  return name;
};

export default useShopFilterName;
